export default function toSnakeCase(string) {
	return string?.replace(/-/g, '_')
}
